exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".streams-drawer-sidebar .streams-drawer-sidebar-header {\n  color: #4E495C;\n}\n.streams-drawer-sidebar cu-icon[name=\"new-feature-lg\"] .cu-icon-lg {\n  fill: #00c9b1;\n  width: 20px;\n  height: 20px;\n}\n.streams-drawer-sidebar .streams-list {\n  max-width: 232px;\n}\n", ""]);

